<template>
	<div>
		<v-expansion-panel v-model="panel" expand>
			<v-expansion-panel-content>
				<template v-slot:header>
					<div>Bloqueo de Transacciones</div>
				</template>
				<v-card>
					<div class="content-card">
						<v-layout row wrap align-center>
							<v-flex xs8>
								<label class="content-card-text">Bloquear transacciones de diarios contables hasta la fecha:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlocking"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'transactionBlocking', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs4>
								<v-btn
									small
									class="btn-action"
									:disabled="!transactionBlocking"
									color="secondary"
									@click="asignDate">Asignar Fecha</v-btn>
							</v-flex>
						</v-layout>
						<v-divider style="margin: 10px 0" />
						<v-layout row wrap align-center>
							<v-flex xs8>
								<label class="content-card-text">Facturas, Pedidos, Proformas:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.sales"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'sales', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8>
								<label class="content-card-text">Compras, Pedidos:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.purchases"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'purchases', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8>
								<label class="content-card-text">CxC, Cobros Múltiples, Recaudaciones:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.accountsReceivable"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'accountsReceivable', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8>
								<label class="content-card-text">CxP, Pagos Múltiples:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.accountsPayable"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'accountsPayable', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8>
								<label class="content-card-text">Caja, Bancos:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.treasury"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'treasury', value: $event })"
								></date-component>
							</v-flex>
							<v-flex xs8>
								<label class="content-card-text">Declaraciones Tributarias:</label>
							</v-flex>
							<v-flex xs4 style="display: flex" align-center>
								<date-component
									:date="transactionBlockingModule.declarations"
									icon="/static/img/calendar.svg"
									@on-input="setModelData({ model: 'declarations', value: $event })"
								></date-component>
							</v-flex>
						</v-layout>
					</div>
				</v-card>
			</v-expansion-panel-content>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					success-text="Aceptar"
					@cancel-button-clicked="$emit('on-close')"
					@accept-button-clicked="submitForm"
					:is-loading="disabled"
				></modal-sidebar-button>
			</section>
		</v-expansion-panel>
	</div>
</template>

<script>
import { addDays, format } from 'date-fns';
import dateComponent from '@/components/autocomplete/date-component';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.loadPeriod();
}

function mounted() {
}

async function loadPeriod() {
	try {
		await this.loadData(`period-details/${this.id}`);
		const { code, deadline, datePresentation, startDate } = this.periods;
		this.model = { code, deadline, datePresentation, startDate };
		this.model.startDate = format(addDays(startDate, 1), 'YYYY-MM-DD');
		this.model.deadline = format(addDays(deadline, 1), 'YYYY-MM-DD');
		this.model.datePresentation = format(datePresentation, 'YYYY-MM-DD');
		this.transactionBlocking = this.periods.transactionBlocking ? format(this.periods.transactionBlocking, 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD');
		this.transactionBlockingModule.sales = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.sales
			? this.periods.transactionBlockingModule.sales : null;
		this.transactionBlockingModule.purchases = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.purchases
			? this.periods.transactionBlockingModule.purchases : null;
		this.transactionBlockingModule.accountsReceivable = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.accountsReceivable
			? this.periods.transactionBlockingModule.accountsReceivable : null;
		this.transactionBlockingModule.accountsPayable = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.accountsPayable
			? this.periods.transactionBlockingModule.accountsPayable : null;
		this.transactionBlockingModule.treasury = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.treasury
			? this.periods.transactionBlockingModule.treasury : null;
		this.transactionBlockingModule.declarations = this.periods.transactionBlockingModule &&
			this.periods.transactionBlockingModule.declarations
			? this.periods.transactionBlockingModule.declarations : null;
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function asignDate() {
	this.transactionBlockingModule = {
		sales: this.transactionBlocking,
		purchases: this.transactionBlocking,
		accountsReceivable: this.transactionBlocking,
		accountsPayable: this.transactionBlocking,
		treasury: this.transactionBlocking,
		declarations: this.transactionBlocking,
	};
}

function setModelData({ model, value }) {
	if (model === 'transactionBlocking') {
		this[model] = value;
	} else {
		this.transactionBlockingModule[model] = value;
	}
}

async function submitForm() {
	this.loading = true;
	this.model = {
		...this.model,
		transactionBlocking: this.transactionBlocking,
		transactionBlockingModule: this.transactionBlockingModule,
	};
	try {
		await this.$http.patch(`period/${this.id}`, this.model);
		this.showNotification('Periodo contable actualizado correctamente.');
		this.$emit('on-close');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	} finally {
		this.loading = false;
	}
}

function disabled() {
	return !this.transactionBlocking ||
		this.loading;
}

function data() {
	return {
		model: {
			deadline: null,
			code: null,
			datePresentation: null,
			startDate: null,
		},
		transactionBlocking: null,
		transactionBlockingModule: {
			sales: null,
			purchases: null,
			accountsReceivable: null,
			accountsPayable: null,
			treasury: null,
			declarations: null,
		},
		loading: false,
		panel: [true],
	};
}

export default {
	name: 'accounting-period-lock-form',
	created,
	mounted,
	data,
	components: {
		dateComponent,
		appTooltipButton,
	},
	methods: {
		loadPeriod,
		asignDate,
		submitForm,
		setModelData,
	},
	computed: {
		disabled,
	},
	props: {
		id: [Number, String],
	},
};
</script>

<style lang="scss" scoped>
.content-card {
	padding: 10px;
	display: flex;
	flex-direction: column;
	&-text {
		font-size: size(medium);
		color: color(grey-text);
	}
}
.btn-action {
	border-radius: 5px;
	color: white !important;
	text-transform: uppercase !important;
	font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/accounting-periods/accounting-period-lock-form.vue